export const sortByKey =  <T, K extends keyof T>(prop: K, dir: number = 1) => (a: T, b: T) => !a[prop] ? -dir : !b[prop] ? dir : (a[prop] + '').toLocaleUpperCase() < (b[prop] + '').toLocaleUpperCase() ? -dir : dir

export const setCookie = (name: string, value: string, days: number) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value || "")  + expires + "; path=/";
}
export const getCookie = (name: string) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
    }
    return null;
}
export const eraseCookie = (name: string) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


  /** Control overlap spacing (Tailwind scale 0, 2, 4, 6, 8, 10, 12...) */
export const getOverlap = (i: number) => {
  return i === 0 ? 'ml-0' : '-ml-14';
}

  /** z-index ordering — first on top */
export const getZIndex = (i: number) => {
  return 'z-' + ( 40 - i * 10);
}

  /** Optional subtle rotation to make it look "fanned" */
export const getRotation = (i: number) => {
  const rotations = ['rotate-0', '-rotate-6', 'rotate-3', '-rotate-3', 'rotate-6'];
  return rotations[i % rotations.length];
}


export const getObjectDifferences = (obj1: {[key:string]: any}, obj2: {[key:string]: any}) => {
  const diff:{[key:string]: any} = {};

  // Find properties in obj1 that are different or not in obj2
  for (const key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
        // Property exists in obj1 but not in obj2
        diff[key] = {
          oldValue: obj1[key],
          newValue: undefined
        };
      } else if (typeof obj1[key] === 'object' && obj1[key] !== null &&
        typeof obj2[key] === 'object' && obj2[key] !== null) {
        // If both are objects, recursively find differences
        const nestedDiff = getObjectDifferences(obj1[key], obj2[key]);
        if (Object.keys(nestedDiff).length > 0) {
          diff[key] = nestedDiff;
        }
      } else if (obj1[key] !== obj2[key]) {
        // Primitive values are different
        diff[key] = {
          oldValue: obj1[key],
          newValue: obj2[key]
        };
      }
    }
  }

  // Find properties in obj2 that are not in obj1
  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (!Object.prototype.hasOwnProperty.call(obj1, key)) {
        // Property exists in obj2 but not in obj1
        diff[key] = {
          oldValue: undefined,
          newValue: obj2[key]
        };
      }
    }
  }

  return diff;
}